import { useTranslation } from 'react-i18next'

import { Box, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'

import { Warning as WarningIcon } from '@mui/icons-material'

import { SyncConflict } from '@/core/offline/types/database.types'
import { NoConflicts } from './NoConflicts'
import { ConflictDetailsProps } from './ConflictDetails'
import { ConflictRow } from './ConflictRow'

type ConflictResolverProps = {
  conflicts: SyncConflict[]
} & Pick<ConflictDetailsProps, 'loading' | 'onResolveConflict' | 'onResolvePatientDuplicate'>

export function ConflictResolver({ conflicts, onResolveConflict, onResolvePatientDuplicate, loading }: ConflictResolverProps) {
  const { t } = useTranslation()

  if (conflicts.length === 0) {
    return <NoConflicts />
  }

  return (
    <Paper>
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <WarningIcon color="warning" />
          <Typography variant="h6">
            {t('sync.conflict.syncConflicts')} ({conflicts.length} {t('sync.conflict.items')})
          </Typography>
        </Stack>
      </Box>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell width="50px"></TableCell>
              <TableCell>{t('sync.dashboard.table.type').toUpperCase()}</TableCell>
              <TableCell>{t('sync.dashboard.table.entity').toUpperCase()}</TableCell>
              <TableCell>{t('sync.conflict.table.conflictType').toUpperCase()}</TableCell>
              <TableCell>{t('sync.conflict.table.detected').toUpperCase()}</TableCell>
              <TableCell align="center">{t('sync.conflict.table.actions').toUpperCase()}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conflicts.map((conflict) => (
              <ConflictRow
                key={conflict._id}
                conflict={conflict}
                loading={loading}
                onResolveConflict={onResolveConflict}
                onResolvePatientDuplicate={onResolvePatientDuplicate}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}
